<template lang='pug'>
div
  v-card-title
    v-toolbar-title.subheading(style="color: grey") Custom Filter :
      span.pr-2
    v-select.hidden-sm-and-down(
      label="Form",
      :items="formShortName",
      v-model="formSelect",
      multiple,
      hide-details,
      style="width: 100px"
    )
    span.pr-2
    v-select.hidden-sm-and-down(
      label="Status",
      :items="formStatus",
      v-model="statusSelect",
      multiple,
      hide-details,
      style="width: 100px"
    )
    span.pr-2
    v-text-field(
      v-model="search",
      append-icon="mdi-magnify",
      label="Search",
      single-line,
      hide-details
    )
  v-data-table.elevation-1(
    :headers="ip.headers"
    :sort-desc.sync="ip.ipDateFormat"
    :items="ip.items"
    :single-expand="true"
    :expanded.sync="expanded"
    item-key="ipNo"
    show-expand
    :search='search'
    :page.sync="page"
    :options.sync="options"
    :server-items-length="ip.jumlah"
    :loading="loading"
    loading-text="Loading... Please wait"
    multi-sortBy
    :footer-props="{'items-per-page-options':[5, 10, 15]}"
    :items-per-page="10"
  )
    template(v-slot:item.ipStatusLabel="{ item }")
      v-chip(
        label,
        small,
        :color="config.status[item.ipStatusColor].color",
        style="width: 100%; justify-content: space-evenly",
        text-color="black"
      ) {{ item.ipStatusLabel }}
    template(v-slot:item.actions="{ item }")

      v-icon(
        small 
        class='mr-2' 
        color="blue" 
        dark
        @click="$refs.openPanasView.dialog = true; getPreview(item._id);"
        v-if="item.ipForm == config.FormCode.izinKerjaDenganPanas"
      ) remove_red_eye
      PanasView(
        v-if="item.ipForm == config.FormCode.izinKerjaDenganPanas"
        :dialogType="dialogType"
        :ip="itemView"
        :approvalUser="dataUsers"
        title="Preview"
        ref="openPanasView"
      )

      v-icon(
        small 
        class='mr-2' 
        color="blue" 
        dark
        @click="$refs.openRTView.dialog = true; getPreview(item._id);"
        v-if="item.ipForm == config.FormCode.izinKerjaMasukRuangTerbatas"
      ) remove_red_eye
      RTView(
        v-if="item.ipForm == config.FormCode.izinKerjaMasukRuangTerbatas"
        :dialogType="dialogType"
        :ip="itemView"
        :approvalUser="dataUsers"
        title="Preview"
        ref="openRTView"
      )

      v-icon(
        small 
        class='mr-2' 
        color="blue" 
        dark
        @click="$refs.openIPView.dialog = true; getPreview(item._id);"
        v-if="item.ipForm == config.FormCode.izinKerjaDiKetinggian"
      ) remove_red_eye
      IPView(
        v-if="item.ipForm == config.FormCode.izinKerjaDiKetinggian"
        :dialogType="dialogType"
        :ip="itemView"
        :approvalUser="dataUsers"
        title="Preview"
        ref="openIPView"
      )

      v-icon(
        small 
        class='mr-2' 
        color="blue" 
        dark
        @click="$refs.openIPKelistrikanView.dialog = true; getPreview(item._id);"
        v-if="item.ipForm == config.FormCode.izinKerjaKelistrikan"
      ) remove_red_eye
      IPKelistrikanView(
        v-if="item.ipForm == config.FormCode.izinKerjaKelistrikan"
        :dialogType="dialogType"
        :ip="itemView"
        :approvalUser="dataUsers"
        title="Preview"
        ref="openIPKelistrikanView"
      )

      v-icon(
        small 
        class='mr-2' 
        color="blue" 
        dark
        @click="$refs.openPenggalianView.dialog = true; getPreview(item._id);"
        v-if="item.ipForm == config.FormCode.izinKerjaPenggalian"
      ) remove_red_eye
      PenggalianView(
        v-if="item.ipForm == config.FormCode.izinKerjaPenggalian"
        :dialogType="dialogType"
        :ip="itemView"
        :approvalUser="dataUsers"
        title="Preview"
        ref="openPenggalianView"
      )

      v-icon(
        small 
        class='mr-2' 
        color="blue" 
        dark
        @click="$refs.openRadioaktifView.dialog = true; getPreview(item._id);"
        v-if="item.ipForm == config.FormCode.izinKerjaRadioaktif"
      ) remove_red_eye
      RadioaktifView(
        v-if="item.ipForm == config.FormCode.izinKerjaRadioaktif"
        :dialogType="dialogType"
        :ip="itemView"
        :approvalUser="dataUsers"
        title="Preview"
        ref="openRadioaktifView"
      )

      v-icon(
        small 
        class='mr-2' 
        color="blue" 
        dark
        @click="$refs.openRAView.dialog = true; getPreview(item._id);"
        v-if="item.ipForm == config.FormCode.izinKerjaRemoteArea"
      ) remove_red_eye
      RAView(
        v-if="item.ipForm == config.FormCode.izinKerjaRemoteArea"
        :dialogType="dialogType"
        :ip="itemView"
        :approvalUser="dataUsers"
        title="Preview"
        ref="openRAView"
      )

      v-icon(
        small 
        class='mr-2' 
        color="blue" 
        dark
        @click="$refs.openPeledakanView.dialog = true; getPreview(item._id);"
        v-if="item.ipForm == config.FormCode.izinKerjaPeledakan"
      ) remove_red_eye
      PeledakanView(
        v-if="item.ipForm == config.FormCode.izinKerjaPeledakan"
        :dialogType="dialogType"
        :ip="itemView"
        :approvalUser="dataUsers"
        title="Preview"
        ref="openPeledakanView"
      )

      v-icon(
        small 
        class='mr-2' 
        color="blue" 
        dark
        @click="$refs.openPengawalanView.dialog = true; getPreview(item._id);"
        v-if="item.ipForm == config.FormCode.izinKerjaPengawalan"
      ) remove_red_eye
      PengawalanView(
        v-if="item.ipForm == config.FormCode.izinKerjaPengawalan"
        :dialogType="dialogType"
        :ip="itemView"
        :approvalUser="dataUsers"
        title="Preview"
        ref="openPengawalanView"
      )

      v-icon(
        small 
        class='mr-2' 
        color="blue" 
        dark
        @click="$refs.openJangkaPendekView.dialog = true; getPreview(item._id, item.ipForm);"
        v-if="item.ipForm == config.FormCode.izinJangkaPendek"
      ) remove_red_eye
      JangkaPendekView(
        v-if="item.ipForm == config.FormCode.izinJangkaPendek"
        :dialogType="dialogType"
        :ip="itemView"
        :approvalUser="dataUsers"
        :fromPage="fromPage"
        title="Preview"
        ref="openJangkaPendekView"
      )

      v-icon(
        small 
        class='mr-2' 
        color="blue" 
        dark
        @click="$refs.openIzinTamuView.dialog = true; getPreview(item._id);"
        v-if="item.ipForm == config.FormCode.izinTamu"
      ) remove_red_eye
      IzinTamuView(
        v-if="item.ipForm == config.FormCode.izinTamu"
        :dialogType="dialogType"
        :ip="itemView"
        :approvalUser="dataUsers"
        title="Preview"
        ref="openIzinTamuView"
      )

      v-icon(
        small 
        class='mr-2' 
        color="blue" 
        dark
        @click="$refs.openIzinProyekView.dialog = true; getPreview(item._id);"
        v-if="item.ipForm == config.FormCode.izinKegiatanProyek"
      ) remove_red_eye
      IzinProyekView(
        v-if="item.ipForm == config.FormCode.izinKegiatanProyek"
        :dialogType="dialogType"
        :ip="itemView"
        :approvalUser="dataUsers"
        title="Preview"
        ref="openIzinProyekView"
      )

      v-icon(
        small 
        class='mr-2' 
        color="blue" 
        dark
        @click="$refs.openUsahaJasaView.dialog = true; getPreview(item._id);"
        v-if="item.ipForm == config.FormCode.izinKerjaUsahaJasa"
      ) remove_red_eye
      IzinUsahaJasaView(
        :dialogType="dialogType",
        :ip="itemView",
        :approvalUser="dataUsers",
        title="Preview"
        ref="openUsahaJasaView"
      )

      router-link(
        v-if="[1, 3].includes(item.ipStatus) && item.ipUser.email == dataUsers.email",
        :to="{ name: routeName(item.ipForm), params: { id: item._id } }"
      )
        v-icon.mr-2(small, title="Edit", color="green") edit
      //- v-icon(small v-if="item.ipStatus == 4 && item.ipAttachmentFiles.docPelaporan" @click="download(item.ipAttachmentFiles.docPelaporan)" style="color: green" title='Download Bukti Pelaporan') cloud_download
      v-btn.text-none.white--text(
        depressed,
        small,
        v-if="showClosing(item)",
        @click.stop="openModal(item)",
        color="purple",
        text-color="white",
        title="Close"
      ) 
        v-icon(small, dark, title="Close") mdi-file-document-edit-outline
        | &nbsp; Close
      UploadBukti(
        v-if="uploadBukti",
        :ip="inputModal",
        :uploadId="getUploadId()",
        :uploadBukti="uploadBukti",
        @interface="closeModal()"
      )

    template(v-slot:expanded-item="{ headers, item }")
      td(:colspan="headers.length")
        TimelinePermitList(
          :item="item"
          :config="config"
          :getWITADate="getWITADate"
          :timelineDetail="timelineDetail"
          :getNameApproverKTT="getNameApproverKTT"
          :getTitleApprover="getTitleApprover"
        )
</template>

<script>
import axios from "axios";
import * as config from "../config/index.json";
import helper from "../helper/index.js";
import PanasView from "@/components/PanasViewNew.vue";
import RTView from "@/components/RTViewNew.vue";
import IPView from "@/components/IPViewNew.vue";
import IPKelistrikanView from "@/components/IPKelistrikanView.vue";
import PenggalianView from "@/components/PenggalianViewNew.vue";
import RadioaktifView from "@/components/RadioaktifViewNew.vue";
import RAView from "@/components/RAViewNew.vue";
import PeledakanView from "@/components/PeledakanViewNew.vue";
import UploadBukti from "@/components/UploadBukti.vue";
import PengawalanView from "@/components/PengawalanViewNew.vue";
import IzinTamuView from "@/components/IzinTamuViewNew.vue";
import JangkaPendekView from "@/components/JangkaPendekViewNew.vue";
import IzinProyekView from "@/components/IzinProyekViewNew.vue";
import IzinUsahaJasaView from "@/components/IzinUsahaJasaViewNew.vue";
import TimelinePermitList from "@/components/TimelinePermitList.vue";
import dayJS from "dayjs";
// import MarkFinished from "@/components/MarkFinished.vue";
import { mapState } from "vuex";
export default {
  name: "TablePermit",
  components: {
    PanasView,
    RTView,
    IPView,
    IPKelistrikanView,
    PenggalianView,
    RadioaktifView,
    RAView,
    PeledakanView,
    UploadBukti,
    PengawalanView,
    IzinTamuView,
    JangkaPendekView,
    IzinProyekView,
    IzinUsahaJasaView,
    TimelinePermitList
    // MarkFinished,
  },
  props: {
    title: String,
    dialogType: String,
    ip: Object,
    fromPage: String
  },
  data() {
    return {
      search: "",
      expanded: [],
      formShortName: [
        { text: "All", value: "all" },
        { header: 'Izin Kerja Khusus' },
        { text: "Izin Kerja Panas", value: "BIB-HSE-PPO-FRM-036-001" },
        { text: "Izin Terbatas", value: "BIB-HSE-PPO-FRM-036-002" },
        { text: "Izin Ketinggian", value: "BIB-HSE-PPO-FRM-036-003" },
        { text: "Izin Penggalian", value: "BIB-HSE-PPO-FRM-036-004" },
        { text: "Izin Kerja Peledakan", value: "BIB-HSE-PPO-FRM-036-007" },
        { text: "Izin Kerja Bertegangan (Vicinity)", value: "BIB-HSE-PPO-FRM-IZIN-KELISTRIKAN" },
        { header: 'Izin Kerja Tambahan' },
        { text: "Izin Kerja Jangka Pendek", value: "BIB-HSE-PPO-FRM-018-03" },
        { text: "Izin Kerja Pengawalan", value: "BIB-HSE-PPO-F-012-01" },
        // { text: "Izin Kerja Kegiatan Usaha Jasa", value: "BIB-HSE-PPO-F-071-02" },
        // { text: "Izin Usulan Perubahan", value: "BIB-HSE-ES-F-2.07-01" },
        { header: 'Izin Kerja Lainnya' },
        { text: "Izin Tamu", value: "BIB-HSE-PPO-IZIN-TAMU" },
        // { text: "Izin Kerja Kegiatan Proyek", value: "BIB-HSE-PPO-F-071-01" },
      ],
      formStatus: [
        { text: "All", value: -1 },
        { text: "Draft", value: 1 },
        { text: "On Approval", value: 2 },
        //- { text: "Need Approval", value: 9 },
        { text: "Need Review", value: 3 },
        { text: "Fully Approved", value: 4 },
        { text: "Rejected", value: 8 },
        { text: "On Closing", value: 10 },
        { text: "Review Closing", value: 11 },
        { text: "Done", value: 12 },
        { text: "Auto Dropped", value: 15 },
        { text: "Auto Cancelled", value: 13 },
        { text: "Auto Rejected", value: 14 },
        { text: "Cancelled", value: 19 }
      ],
      formName: config.FormName,
      formSelect: "",
      config: config.default,
      pagination: {
        sortBy: ["ipDate"],
        descending: [true],
      },
      uploadBukti: false,
      docPelaporan: null,
      inputModal: {},
      options: {
        sortBy: ['ipDate'],
        sortDesc: [true]
      },
      loading: false,
      request: null,
      page: 1,
      itemsPerPage: 10,
      statusSelect: [2, 3],
      itemView: {}
    };
  },
  beforeDestroy() {
    this.$store.state.listPermit.data = [];
    this.$store.state.listPermit.jumlah = 0
  },
  computed: {
    ...mapState(["dataUsers", "API_URL"]),
  },
  methods: {
    showClosing(item) {
      const doesPelaporanNotExist =
        item.ipAttachmentFiles != null
          ? !item.ipAttachmentFiles.docPelaporan
          : true;
      return (
        item.ipForm != "BIB-HSE-PPO-FRM-018-03" &&
        !item.ipVisitors &&
        item.ipStatus == 4 &&
        item.ipUser.email == this.dataUsers.email &&
        doesPelaporanNotExist
      );
    },
    dayjs(val = undefined) {
      return dayJS(val);
    },
    routeName(val) {
      switch (val) {
        case "BIB-HSE-PPO-FRM-036-001":
          return "Edit Izin Kerja Dengan Panas";

        case "BIB-HSE-PPO-FRM-036-002":
          return "Edit Izin Kerja Ruang Terbatas";

        case "BIB-HSE-PPO-FRM-036-003":
          return "Edit Izin Kerja Di Ketinggian";

        case "BIB-HSE-PPO-FRM-036-004":
          return "Edit Izin Kerja Penggalian";

        case "BIB-HSE-PPO-FRM-036-005":
          return "Edit Izin Kerja Radioaktif";

        case "BIB-HSE-PPO-FRM-036-006":
          return "Edit Izin Kerja Remote Area";

        case "BIB-HSE-PPO-FRM-036-007":
          return "Edit Izin Kerja Peledakan";

        case "BIB-HSE-PPO-F-012-01":
          return "Edit Izin Kerja Pengawalan";

        case "BIB-HSE-PPO-F-012-02":
          return "Edit Lampiran Izin Kerja Pengawalan Unit";
        case 'BIB-HSE-PPO-F-071-01':
          return 'Edit Izin Melaksanakan Kegiatan Proyek';
        case 'BIB-HSE-PPO-F-071-02':
          return 'Edit Izin Melaksanakan Kegiatan Usaha Jasa';
        default:
          return "";
      }
    },
    timelineDetail(postAs, index, formCode = "") {
      //TODO: need to refactor for simplification of switch case
      switch (postAs) {
        case "deptHead":
          if (formCode == "BIB-HSE-PPO-IZIN-TAMU") return "DIC / PJO";
          else if (formCode == "BIB-HSE-PPO-FRM-018-03" || formCode == "BIB-HSE-PPO-F-071-01" || formCode == "BIB-HSE-PPO-F-071-02") return "DIC / Kustodian";
          return "Dept. Head / Cust Dept.head";
        case "divHead":
          return "Div.Head / Cust Div.head";
        case "custodianDeptHead":
          return "Custodian Dept Head";
        case "custodianDivHead":
          return "Custodian Div Head";
        case "ohsDeptHead":
          if (formCode == "BIB-HSE-PPO-F-071-01" || formCode == "BIB-HSE-PPO-F-071-02") return "OHS Dept Head (PNC)";
          return "OHS Dept Head";
        case "hseDivHead":
          return "HSE Div Head";
        case "approver":
          return formCode == "BIB-HSE-PPO-IZIN-TAMU" ? "KTT / HSE Head" : "KTT";
        case "teamLeader":
          return "Team Leader / Custodian Dept Head / Sec Head";
        case "pjo":
        case "secHead":
          return "Atasan / PJO / Section Head";
        case "karyawan":
          return "Pekerja";
        case "waskat":
          return `Waskat ${index + 1}`;
        case "atasan":
          return `Atasan / PJO / Section Head`;
        case "requestor":
          return "PJO";
        case "verificator1":
          return "DIC/Custodian";
        case "verificator2":
          return "OHS Dept Head (PNC)";
        case "safetyInternal":
          return "Safety Internal";
        case "safetyMitra":
          return "Safety Mitra";
        default:
          return "approverDefault";
      }
    },
    getWITADate: helper.getWITADate,
    download(file) {
      this.$downloadFile(file);
    },
    closeModal: function () {
      this.uploadBukti = false;
      this.inputModal = {};
    },
    openModal(input) {
      this.uploadBukti = true;
      this.inputModal = input;
    },
    getUploadId() {
      return Date.now();
    },
    cancel() {
      this.request.cancel()
    },
    getOptions() {
      clearTimeout(this._timerId)
      if (this.request) this.cancel();

      this._timerId = setTimeout(() => {
        this.$store.state.newMyApprovalPermitv2.data = [];
        this.$store.state.listPermit.data = [];
        this.loading = true;

        if (this.options.page == undefined) {
          this.options.page = 1
        }

        if (this.options.rowsPerPage == undefined) {
          this.options.rowsPerPage = this.itemsPerPage
        }

        const axiosSource = axios.CancelToken.source()
        this.request = { cancel: axiosSource.cancel }

        if (this.options.sortBy) {
          const direction = this.options.sortDesc[0] ? 'desc' : 'asc';
          let sortBy = this.options.sortBy;

          if (sortBy[0] == "ipDateFormat") {
            sortBy = ["ipDate"];
          } else if (sortBy[0] == "ipFormShortName") {
            sortBy = ["ipForm"]
          }

          let statusForm = this.statusSelect

          if (statusForm.length < 1) {
            statusForm = [-1]
          } else if (statusForm.length > 1 && statusForm.slice(-1) == -1) {
            statusForm = [-1]
            this.statusSelect = [-1]
          } else if (statusForm.length > 1 && statusForm[0] == -1) {
            statusForm.splice(0, 1)
          }

          let formSelect = this.formSelect

          if (formSelect.length <= 1 && formSelect[0] == "all") {
            formSelect = ""
          } else if (formSelect.length > 1 && formSelect.slice(-1) == "all") {
            formSelect = ""
            this.formSelect = ["all"]
          } else if (formSelect.length > 1 && formSelect[0] == "all") {
            formSelect.splice(0, 1)
          }

          axios.get(
            `${this.$store.state.API_URL}/v1/requests`,
            {
              params: {
                email: this.$store.state.dataUsers.email,
                desiredStatus: statusForm != null ? JSON.stringify(statusForm) : JSON.stringify([2, 3]),
                forms: formSelect != "" ? JSON.stringify(formSelect) : [],
                searchQuery: this.search,
                sortBy: sortBy[0],
                order: direction,
                page: this.options.page,
                perPage: this.options.rowsPerPage
              },
              headers: { "Authorization": `Bearer ${this.$store.state.token}` }
            }
          ).then(res => {
            this.page = this.options.page
            this.$store.state.listPermit.data = res.data.data;
            this.$store.state.listPermit.jumlah = res.data.totalData;
            this.request = null
            this.$store.state.loader = false;
          })
            .catch(err => {
              console.log(err)
              this.$store.state.loader = false;
            })
            .finally(() => {
              this.loading = false
              this.$store.state.loader = false;
            });

        }
      }, 500)
    },
    getPreview(id, ipForm = null) {
      axios.get(
        `${this.$store.state.API_URL}/v1/requests/getById/` + id,
        {
          params: { ipForm },
          headers: { "Authorization": `Bearer ${this.$store.state.token}` }
        }
      ).then(res => {
        this.itemView = res.data[0]
        this.$store.state.loader = false;
      })
        .catch(err => {
          console.log(err)
          this.$store.state.loader = false;
        })
        .finally(() => {
          this.$store.state.loader = false;
        });
    },
    getNameApproverKTT(item) {
      return helper.getKTTApproverName(item)
    },
    getTitleApprover(item) {
      if (item.matrix.includes('KTT')) {
        return 'Kepala Teknik Tambang'
      } else {
        return item.title
      }
    }
  },
  watch: {
    options(val) {
      this.itemsPerPage = val.itemsPerPage
      this.getOptions()
    },
    search() {
      this.getOptions()
    },
    formSelect() {
      this.page = 1
      this.getOptions()
    },
    statusSelect() {
      this.page = 1
      this.getOptions()
    }
  },
};
</script>

<style>
.pointer {
  cursor: pointer;
}
</style>